<template>
  <validation-observer v-if="dialogComputed" ref="observer" v-slot="{ invalid }">
    <v-dialog v-model="dialogComputed" max-width="500px" scrollable persistent>
      <v-card>
        <v-card-title class="primary white--text py-2">
          {{ $t('ELE0016') }}
          <v-spacer />
          <Btn icon="mdi-close" @click="close" depressed iconProp color="white" />
        </v-card-title>
        <v-card-text class="px-0">
          <v-container>
            <v-row>
              <v-col>
                <TextFieldInput :label="$t('ELE0033')" v-model="title" :maxLength="60" required />
              </v-col>
            </v-row>
            <v-row class="pb-0">
              <v-col>
                <FileInput v-model="file" :label="$t('ELE0035')" required :rules="`maxFileSize:${maxFileSize}`" />
              </v-col>
            </v-row>
          </v-container>
          <v-divider />
        </v-card-text>
        <v-card-actions class="d-flex align-end justify-end">
          <Btn :label="$t('ELE0105')" @click="onClickSet" :disabled="invalid" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </validation-observer>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'

import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput'
import Btn from '@/components/atoms/base/button/Btn'
import FileInput from '@/components/atoms/base/file/FileInput'

export default {
  name: 'InspAttachmentDialog',

  mixins: [APIUtils, Message, Loading],

  components: {
    ValidationObserver,
    TextFieldInput,
    Btn,
    FileInput,
  },
  data() {
    return {
      title: '',
      file: null,
    }
  },

  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    maxFileSize: {
      //In Bytes
      type: Number,
      required: false,
      default: 52428800,
    },
  },

  computed: {
    dialogComputed: {
      get() {
        return this.dialog
      },
      set(value) {
        this.$emit('update:dialog', value)
      },
    },
  },
  methods: {
    close() {
      this.title = ''
      this.file = null
      this.dialogComputed = false
    },
    onClickSet() {
      if (this.file) {
        const fileDetail = {
          title: this.title,
          file: this.file,
        }
        this.$emit('change', fileDetail)
        this.close()
      }
    },
  },
}
</script>
